import type { ResultsWithReview } from '../services/results.service';

export interface ReviewQuestion {
  id: string;
  questionNumber: number;
  question: string;
  context?: string;
  options: string[];
  userAnswer: number | null;
  correctAnswer: number | null;
  isCorrect: boolean | null;
  explanation: string;
  topic: string;
  transcript?: string;
  aiScore?: number;
  aiFeedback?: string;
  writtenAnswer?: string;
  hasAudio?: boolean;
  hasRecording?: boolean;
  hasImage?: boolean;
  criteriaScores?: Array<{ criterion: string; met: boolean; comment: string }>;
}

export function mapApiToReviewQuestions(data: ResultsWithReview): ReviewQuestion[] {
  return data.answers.map((a, idx) => {
    const questionType = a.questionType || 'reading';
    const options = a.options || [];
    const userAns = typeof a.answer === 'string' ? a.answer : null;
    const correctAns = typeof a.correctAnswer === 'string' ? a.correctAnswer : Array.isArray(a.correctAnswer) ? a.correctAnswer[0] : null;

    return {
      id: a.questionId,
      questionNumber: idx + 1,
      question: a.questionText || `Question ${idx + 1}`,
      context: a.context,
      options,
      userAnswer: userAns == null ? null : options.indexOf(userAns),
      correctAnswer: correctAns == null ? null : options.indexOf(correctAns),
      isCorrect: a.isCorrect ?? null,
      explanation: a.explanation || '',
      topic: a.theme || questionType,
      transcript: a.transcript,
      aiScore: a.aiScore,
      aiFeedback: a.aiFeedback,
      writtenAnswer: (questionType === 'essay' || questionType === 'writing') && typeof a.answer === 'string' ? a.answer : undefined,
      hasAudio: questionType === 'listening' && !!a.media?.audio,
      hasRecording: questionType === 'speaking' && !!a.answer,
      hasImage: questionType === 'knm' && !!a.media?.image,
      criteriaScores: a.criteriaScores,
    };
  });
}
